import React from "react";
import { Icon } from "semantic-ui-react";
import { Progress } from "antd";
import { Tabs } from "antd";
import LossBarChart from "./LossBarChart";
import PerHazardDonutCharts from "./loss_donut";
const { TabPane } = Tabs;

const LossPercentComponent = (props) => {
  const generalKeys = [
    "Rainfall Flood Loss",
    "River Flood Loss",
    "Storm Surge Loss",
    "Typhoon Loss",
    "Temprature/heat loss",
    "",
    "",
    "",
    "",
  ];

  const detailedKeys = [
    "Total Loss",
    "Rainfall Flood Damage",
    "River Flood Damage",
    "Storm Surge Damage",
    "Typhoon Damage",
    "Operational Rainfall Flood Loss",
    "Operational River Flood Loss",
    "Operational Storm Surge Loss",
    "Operational Typhoon Loss",
    "Temprature/heat loss",
  ];

  const totalKeys = [
    "Total Loss",
    "Total Damage",
    "Total Operational",
    "Total Inventory Loss",
  ];

  const inventoryKeys = [
    "Rainfall Flood",
    "River Flood",
    "Storm Surge",
    "Typhoon",
  ];

  // 👇 maxLabels is the superset of all unique hazard keys across tabs
  const maxLabels = [
    ...new Set([
      ...generalKeys,
      ...detailedKeys,
      ...totalKeys,
      ...inventoryKeys,
    ]),
  ];

  return (
    <div>
      <Tabs defaultActiveKey="general">
        <TabPane tab="Per Hazard" key="general">
          <LossBarChart
            dataSource={props.data.general}
            newDataSource={props.newdata.general}
            allLabels={maxLabels}
            formatType="percent"
          />
        </TabPane>
        <TabPane tab="Detailed" key="detailed">
          <LossBarChart
            dataSource={props.data.detailed}
            newDataSource={props.newdata.detailed}
            allLabels={maxLabels}
            formatType="percent"
          />
        </TabPane>
        <TabPane tab="Overall" key="total">
          <LossBarChart
            dataSource={props.data.total}
            newDataSource={props.newdata.total}
            allLabels={maxLabels}
            formatType="percent"
          />
        </TabPane>
        <TabPane tab="Inventory Loss" key="inventory">
          <LossBarChart
            dataSource={props.inventory}
            newDataSource={props.inventory_2020}
            allLabels={maxLabels}
            formatType="percent"
          />
        </TabPane>
      </Tabs>
      <PerHazardDonutCharts
        year={props.year}
        baselineData={props.data.general}
        projectedData={props.newdata.general}
        formatType="percent"
      />
    </div>
  );
};

export default LossPercentComponent;
